import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerModelloUnicoDichiarazioneAmbientaleModalComponent} from './worker-modello-unico-dichiarazione-ambientale-modal';

export const WorkerModelloUnicoDichiarazioneAmbientaleModalModule: string = ng
    .module('worker-modello_unico_dichiarazione_ambientale-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerModelloUnicoDichiarazioneAmbientaleModalComponent', WorkerModelloUnicoDichiarazioneAmbientaleModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-modello-unico-dichiarazione-ambientale-modal/worker-modello-unico-dichiarazione-ambientale-modal.module.ts